import React, { useState } from "react";
import "./Sidebar.css";
import { UilSignOutAlt } from "@iconscout/react-unicons";
import { UilBars } from "@iconscout/react-unicons";
import { motion } from "framer-motion";
// import { SidebarData } from "../../../Data/Data";

const Sidebar = () => {

    const [expanded, setExpaned] = useState(true)

    const sidebarVariants = {
        true: {
            left: '0'
        },
        false: {
            left: '-60%'
        }
    }
    return (
        <>
            <div className="bars" style={expanded ? { left: '60%' } : { left: '5%' }} onClick={() => setExpaned(!expanded)}>
                <UilBars />
            </div>
            <motion.div className='sidebar'
                variants={sidebarVariants}
                animate={window.innerWidth <= 768 ? `${expanded}` : ''}
            >
                {/* logo */}
                <div className="logo">
                    {/* <img src={Logo} alt="logo" /> */}
                    <span>
                        At<span>hnu</span>m
                    </span>
                </div>

                <div className="menu">
                    {/* {SidebarData.map((item, index) => {
                        return ( */}
                    <div
                        className="menuItem active"
                    // className={selected === index ? "menuItem active" : "menuItem"}
                    // key={index}
                    // onClick={() => setSelected(index)}
                    >
                        {/* / <item.icon /> */}
                        <span>Dashboard</span>
                    </div>
                    {/* );
                    })} */}
                    {/* signoutIcon */}
                    <div className="menuItem">
                        {/* <UilSignOutAlt /> */}
                    </div>
                </div>
            </motion.div>
        </>
    );
};

export default Sidebar;
